<template>
    <div class="empty-page">
        <img src="@/assets/images/queshengtu_1@2x.png" alt="">
        <div class="empty-page-title">{{ title }}</div>
    </div>
</template>
<script>
export default {
    name: 'EmptyPage',
    props: {
        title: {
            type: String,
            default: '没有数据'
        }
    },

}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';

.empty-page {
    padding: .5rem;
    text-align: center;
    img {
        width: 1rem;
        vertical-align: bottom;
    }
    .empty-page-title {
        color: $grey_border_color_ccc;
        font-size: .14rem;
        line-height: .4rem;
        text-align: center;
    }
}
</style>